/**
 * Formatação de CPF/CNPJ.
 *
 * Convenção do projeto: valor persistido no banco são APENAS dígitos
 * (sem pontuação). A UI exibe formatado e grava só dígitos.
 */

export function formatCPF(cpf) {
  if (!cpf) return '';
  const d = String(cpf).replace(/[^0-9]/g, '');
  if (d.length !== 11) return String(cpf);
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

export function formatCNPJ(cnpj) {
  if (!cnpj) return '';
  const d = String(cnpj).replace(/[^0-9]/g, '');
  if (d.length !== 14) return String(cnpj);
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}

export function formatDocument(doc) {
  if (!doc) return '';
  const d = String(doc).replace(/[^0-9]/g, '');
  if (d.length === 11) return formatCPF(d);
  if (d.length === 14) return formatCNPJ(d);
  return String(doc);
}

/** Extrai só dígitos — usar antes de salvar no banco. */
export function onlyDigits(v) {
  if (!v) return '';
  return String(v).replace(/[^0-9]/g, '');
}
